module.exports = __webpack_public_path__ + "img/android-user.caada797.png";